<template>
  <el-row style="display: flex;flex-direction: column;height: 100%">
    <el-row style="height: 26px;">
      <span style="line-height: 26px;">
        {{ $t('dataset.add_db_table') }}
      </span>
      <el-row style="float: right">
        <el-button size="mini"
          @click="cancel">
          {{ $t('dataset.cancel') }}
        </el-button>
        <el-button size="mini"
          type="primary"
          :disabled="checkTableList.length < 1"
          @click="save">
          {{ $t('dataset.confirm') }}
        </el-button>
      </el-row>
    </el-row>
    <el-divider />
    <el-row>
      <el-form :inline="true">
        <el-form-item class="form-item">
          <el-select v-model="dataSource"
            filterable
            :placeholder="$t('dataset.pls_slc_data_source')"
            size="mini">
            <el-option v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item class="form-item">
          <el-select v-model="mode"
            filterable
            :placeholder="$t('dataset.connect_mode')"
            size="mini">
            <el-option :label="$t('dataset.direct_connect')"
              value="0" />
            <el-option :label="$t('dataset.sync_data')"
              value="1"
              :disabled="!kettleRunning" />
          </el-select>
        </el-form-item>
        <el-form-item class="form-item"
          style="float: right;">
          <el-input v-model="searchTable"
            size="mini"
            placeholder="请输入关键字"
            prefix-icon="el-icon-search"
            clearable />
        </el-form-item>
        <el-form-item class="form-item"
          style="float: right;">
          <el-select v-model="theme"
            filterable
            clearable
            placeholder="请选择主题"
            size="mini">
            <el-option v-for="item in themeList"
              :key="item.id"
              :label="item.name"
              :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-col style="overflow-y: auto;">
      <el-checkbox-group v-model="checkTableList"
        size="small">
        <el-tooltip v-for="t in tableData"
          :key="t.key"
          effect="dark"
          :content="t.tableName ? t.tableName : t.name"
          placement="bottom">
          <el-checkbox border
            style="width:32%;overflow: hidden;"
            :label="t.tableName ? t.tableName : t.name"
            :disabled="!t.enableCheck">{{t.tableName ? t.tableName : t.name}}</el-checkbox>
        </el-tooltip>
      </el-checkbox-group>
    </el-col>
  </el-row>
</template>

<script>
import { listDatasource, post, isKettleRunning } from '@/api/dataset/dataset'

export default {
  name: 'AddDB',
  props: {
    param: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      searchTable: '',
      options: [],
      dataSource: '',
      tables: [],
      checkTableList: [],
      mode: '0',
      theme: '',
      themeList: [],
      tableData: [],
      kettleRunning: false
    }
  },
  watch: {
    dataSource(val) {
      this.themeList = []
      this.theme = ''
      if (val) {
        post('/datasource/getTables', { id: val }).then(response => {
          this.tables = response.data
          this.tableData = JSON.parse(JSON.stringify(this.tables))
        })
        post('/datasource/getSubject', { id: val }).then(response => {
          this.themeList = response.data
        })
      }
    },
    searchTable(val) {
      if (val && val !== '') {
        this.tableData = JSON.parse(JSON.stringify(this.tables.filter(ele => { return ele.tableName ? ele.tableName.includes(val) : ele.name.includes(val) })))
        this.tableData = this.unique(this.tableData)
      } else {
        if (!this.theme) {
          this.tableData = JSON.parse(JSON.stringify(this.tables))
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.tables.filter(ele => { return ele.subjectName === this.theme })))
        }
      }
    },
    theme(val) {
      if (val && val !== '') {
        this.tableData = JSON.parse(JSON.stringify(this.tables.filter(ele => { return ele.subjectName === val })))
      } else {
        if (!this.searchTable) {
          this.tableData = JSON.parse(JSON.stringify(this.tables))
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.tables.filter(ele => { return ele.tableName ? ele.tableName.includes(this.searchTable) : ele.name.includes(this.searchTable) })))
          this.tableData = this.unique(this.tableData)
        }
      }
    }
  },
  mounted() {
    this.initDataSource()
  },
  activated() {
    this.initDataSource()
  },
  created() {
    this.kettleState()
  },
  methods: {
    unique(arr) {
      const obj = {}
      const newArr = arr.reduce((item, next) => {
        obj[next.tableName] ? '' : (obj[next.tableName] = true && item.push(next))
        return item
      }, [])
      return newArr
    },
    initDataSource() {
      listDatasource().then(response => {
        this.options = response.data
      })
    },
    kettleState() {
      isKettleRunning().then(res => {
        this.kettleRunning = res.data
      })
    },
    save() {
      console.log(this.checkTableList);
      // console.log(this.scene);
      let ds = {}
      this.options.forEach(ele => {
        if (ele.id === this.dataSource) {
          ds = ele
        }
      })
      const sceneId = this.param.id
      const dataSourceId = this.dataSource
      const tables = []
      const mode = this.mode
      this.checkTableList.forEach(function (name) {
        debugger
        tables.push({
          name: ds.name + '_' + name,
          sceneId: sceneId,
          dataSourceId: dataSourceId,
          type: 'db',
          mode: parseInt(mode),
          info: JSON.stringify({ table: name.split('/')[0] })
        })
      })
      post('/dataset/table/batchAdd', tables).then(response => {
        // this.$store.dispatch('dataset/setSceneData', new Date().getTime())
        this.$emit('saveSuccess', tables[0])
        this.cancel()
      })
    },

    cancel() {
      this.dataReset()
      // this.$router.push('/dataset/home')
      this.$emit('switchComponent', { name: '' })
    },

    dataReset() {
      this.searchTable = ''
      this.options = []
      this.dataSource = ''
      this.tables = []
      this.checkTableList = []
    }
  }

}
</script>

<style scoped>
.el-divider--horizontal {
  margin: 12px 0;
}

.form-item {
  margin-bottom: 6px;
}

.el-checkbox {
  margin-bottom: 14px;
  margin-left: 0;
  margin-right: 14px;
}

.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}

span {
  font-size: 14px;
}
::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  width: 9px;
  height: 4px;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.el-form-item--medium .el-form-item__content {
  line-height: 28px !important;
}
</style>
